import IconChecklist from "../../../../../atoms/CustomIcons/IconChecklist";

export default function Checklists() {
  return (
    <div>
      <h2 className="tabs_content_heading">
        <IconChecklist /> Checklists
      </h2>
      <p className="tabs_content_subheading">Customize your checklists.</p>
    </div>
  );
}
